module.exports = __webpack_public_path__ + "static/media/edit_origin.1ad51a9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/via/images/edit_origin.svg
// module id = 473
// module chunks = 0